import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import DiscountStore from './DiscountStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';
import * as constants from 'Constants';


class ContentStore {

  @setter @observable completionNoteHtml;
  @setter @observable discounts;

  static create(data={}) {
    const instance = new ContentStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "completionNoteHtml": "",
      "discounts": [],
    };
  }

  constructor(defaults=ContentStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ContentStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "completionNoteHtml", "accessor": "completion_note_html"},
      {"field": "discounts", "accessor": "discounts", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": DiscountStore},
    ];
  }

  @action async deserialize(data) {
    // sort discounts so that min discount comes first
    data.discounts.sort((a, b)=> (a.min_amount > b.min_amount ? 1 : -1));
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}


export default ContentStore;
